export enum ClientVersionStore {
  AppleAppStore = 'AppleAppStore',
  GooglePlay = 'GooglePlay',
  HuaweiAppGallery = 'HuaweiAppGallery',
  RuStore = 'RuStore',
}

export interface ClientVersionModel {
  id: string;
  store: ClientVersionStore;
  versionNumber: number;
  isMandatory: boolean;
  createdAt: string;
}

export interface ClientVersionsWithMetaModel {
  items: ClientVersionModel[];
  totalCount: number;
  pageInfo: PageInfoModel;
}

export interface ClientVersionsFilter {
  pageSize?: number;
  after?: string;
}

export interface CreateClientVersionDTO {
  store: ClientVersionStore;
  versionNumber: number;
  isMandatory: boolean;
}
